module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/253-seychelles-a7398a75a026510445d035b3df046ce4.svg";